import React from "react";
import Button from "./foundational/Button";
import { nombreMundo } from "../lib/mundos";

/**
 * BandaMundo: el aviso fijo de que la persona está fuera de su casa (tres
 * mundos, docs/plan-tres-mundos.md, M4). Dice dónde está y la devuelve a su
 * casa con un toque, "como los perfiles de Chrome". No se descarta: mientras
 * esté de visita, la banda está, para que nadie confunda el mundo visitado
 * con el suyo.
 *
 * "con el plan gratis" aparece SOLO cuando es verdad que cambia algo: con el
 * acceso abierto todos los mundos valen igual, y a quien no tiene plan nada
 * le cambia. No hay precio ni compra (venta solo en la web): la banda dice el
 * límite, no vende, y la ve también la app instalada. Va fija bajo el header
 * (sticky) para que no se pierda al bajar por la pantalla.
 *
 * Props:
 *  - mundo: id del mundo visitado ('estudiante' | 'enfermero' | 'tens').
 *  - casa: id de la casa (el rol real).
 *  - conPlanGratis: si en este mundo rige el plan gratis en vez de su plan.
 *  - onVolver(): vuelve a la casa.
 */
export default function BandaMundo({ mundo, casa, conPlanGratis = false, onVolver }) {
  const donde = nombreMundo(mundo);
  const vuelta = nombreMundo(casa);
  if (!donde || !vuelta) return null;
  return (
    <div
      role="region"
      aria-label="Dónde estás en MiPAE"
      className="no-print sticky z-20 w-full border-b border-edge bg-surface"
      style={{ top: "calc(3.5rem + 1px + env(safe-area-inset-top, 0px))" }}
    >
      <div className="max-w-[820px] lg:max-w-[1240px] mx-auto px-3 min-[400px]:px-4 py-1 flex flex-wrap items-center justify-between gap-x-3 gap-y-1">
        <p className="text-small text-ink font-sans leading-snug min-w-0">
          Estás en <span className="font-semibold">{donde}</span>{conPlanGratis ? ", con el plan gratis." : "."}
        </p>
        {/* "Volver a tu casa" y no el nombre entero: así la banda cabe en un
            renglón en un teléfono (con el nombre se partía en dos y se comía
            unos 70 px fijos arriba). El nombre de la casa va solo para el
            lector de pantalla, después del texto visible. */}
        <Button variant="secondary" size="sm" onClick={onVolver} className="min-h-[44px] shrink-0">
          Volver a tu casa<span className="sr-only">, {vuelta}</span>
        </Button>
      </div>
    </div>
  );
}
